import { LogoWhite } from "@src/components/elements";
import { Nav } from "@src/components/modules/Nav/Nav";
import { useSession } from "@src/contexts/SessionContext";
import { useSudoziQuery } from "@src/infrastructure/useSudoziQuery";
import { Page } from "@src/shared/pages";
import { GetCompanyLogoSignedUrlRoute } from "@src/sudozi-schemas/api-route-schemas";
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components/macro";

const StyledRoot = styled.aside`
  display: flex;
  flex-direction: column;
  .logos {
    padding: 1rem;
    display: flex;
    justify-content: space-between;

    .logo {
      width: calc((var(--sidebar-width) / 2) - 2rem);
    }
  }
`;

export const DesktopSidebar: React.FC<{
  activePage?: Page;
  className?: string;
}> = ({ activePage }) => {
  const { vendorUser } = useSession();
  const { data } = useSudoziQuery({
    route: GetCompanyLogoSignedUrlRoute,
    queryKey: ["logo-signed-url"],
    options: {
      enabled: !vendorUser,
    },
  });

  return (
    <StyledRoot>
      <div className="row logos spread">
        <Link
          to={Page.HOME}
          style={{
            fontSize: 0,
          }}
        >
          <LogoWhite className="logo" />
        </Link>
        {data?.lightLogoUrl ? (
          <>
            <div
              style={{
                width: "1px",
                height: "1.5rem",
                backgroundColor: "white",
                margin: "auto 0",
              }}
            />
            <img src={data.lightLogoUrl} className="logo" />
          </>
        ) : null}
      </div>
      <Nav activePage={activePage} />
    </StyledRoot>
  );
};
